/**
 * For use with dangerouslySetInnerHTML.
 * @param {String} html A string of HTML, e.g. returned from a WYSIWYG editor.
 * @returns {Object}
 * @property {String} __html The same html string passed in.
 * @see https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
 */
const createMarkup = html => (
  { __html: html }
);

export default createMarkup;
